// @flow
import {
    feedFailure,
    feedRequest,
    feedSuccess,
    resetFeed
} from "../actions/feed.actions";
import { handleActions } from "redux-actions";
import { setupPostPagedRequest } from "./request.reducer";
import {
    deleteCorrectionSuccess,
    reportCorrectionSuccess,
    submitCommentSuccess,
    submitCorrectionSuccess,
    toggleCorrectionReactionSuccess
} from "../actions/correction.actions";
import {
    deletePostSuccess,
    reportPostSuccess,
    togglePostReactionSuccess
} from "../actions/post.actions";
import { PagedRequest, RequestState } from "../records/request.record";
import Record from "../flow/Record";

export class Feed extends Record({
    feedPagedRequest: new PagedRequest(),
    lastSort: "score",
    sort: "score"
}) {
    feedPagedRequest: RequestState;
    sort: string;
    lastSort: string;
}

const request = setupPostPagedRequest("feedPagedRequest");

const feed = handleActions(
    {
        [feedRequest]: request.start,
        [feedSuccess](state, action) {
            return request.filter(request.success(state, action), node => {
                return node.reportedUsers.indexOf(action.payload.userId) === -1;
            });
        },
        [resetFeed](state) {
            return request.reset(state);
        },
        [feedFailure]: request.failure,
        [toggleCorrectionReactionSuccess]: request.updateCorrection,
        [togglePostReactionSuccess]: request.updatePost,
        [submitCommentSuccess]: request.updateCorrection,
        [submitCorrectionSuccess]: request.updateCorrection,
        [deletePostSuccess]: request.deletePost,
        [reportPostSuccess]: request.deletePost,
        [deleteCorrectionSuccess]: request.deleteCorrection,
        [reportCorrectionSuccess]: request.deleteCorrection
    },
    new Feed()
);

export default feed;



// WEBPACK FOOTER //
// ./src/reducers/feed.reducer.js